import { MarketTypes } from "app/utils/const";
import React from "react";
import { connect } from "react-redux";
import { BetSlipHelper } from "../../../../helpers/betSlipHelper";
import type {
  EventMarketPeriodType,
  EventType,
} from "../../../../types/eventType";
import AsianEventCellOutright from "../AsianMarketPeriods/components/AsianEventCellOutright/AsianEventCellOutright";
import "./AsianEventMarketPeriod.scss";
import { AsianEvent1x2 } from "./components/AsianEventMarket1x2/AsianEvent1x2";
import AsianEventMarketHandicapContainer from "./components/AsianEventMarketHandicapContainer/AsianEventMarketHandicapContainer";
import AsianEventMarketTotalContainer from "./components/AsianEventMarketTotalContainer/AsianEventMarketTotalContainer";

type Props = {
  marketPeriod: EventMarketPeriodType;
  event: EventType;
  addBetSlip: (...args: Array<any>) => any;
  toggleCollapsible: (...args: Array<any>) => any;
  highestNumberOfMarkets: number;
  line: string;
};

const AsianEventMarketPeriod = (props: Props): React.JSX.Element => {
  const addBetSlip = (runner: any) => {
    let betSlip = BetSlipHelper.prepareBetSlip(props.event, runner);
    props.addBetSlip(betSlip);
  };

  const selectType = (marketType: any) => {
    let type;

    if (
      marketType.marketType === MarketTypes.ONE_X_TWO ||
      marketType.marketType === MarketTypes.MONEY_LINE ||
      marketType.marketType === MarketTypes.DRAW_NO_BET ||
      marketType.marketType === MarketTypes.CORNER_ONE_X_TWO
    ) {
      type = MarketTypes.ONE_X_TWO;
    }

    if (
      marketType.marketType === MarketTypes.HANDICAP ||
      marketType.marketType === MarketTypes.CORNER_HANDICAP
    ) {
      type = MarketTypes.HANDICAP;
    }

    if (
      marketType.marketType === MarketTypes.TOTAL ||
      marketType.marketType === MarketTypes.CORNER_TOTAL
    ) {
      type = MarketTypes.TOTAL;
    }
    if (marketType.marketType === MarketTypes.OUTRIGHT) {
      type = MarketTypes.OUTRIGHT;
    }

    return type;
  };

  const { marketPeriod, event, highestNumberOfMarkets, line } = props;
  const marketTypes = marketPeriod.marketTypes;

  return (
    <React.Fragment>
      {marketTypes &&
        marketTypes.map(marketType => {
          let type = selectType(marketType);

          switch (type) {
            case MarketTypes.ONE_X_TWO:
              return (
                <AsianEvent1x2
                  key={`${event.id}_${marketType.marketType}`}
                  market={marketType.markets[0]}
                  addBetSlip={addBetSlip}
                  event={event}
                  highestNumberOfMarkets={highestNumberOfMarkets}
                  line={line}
                />
              );

            case MarketTypes.TOTAL:
              return (
                <AsianEventMarketTotalContainer
                  key={`${event.id}_${marketType.marketType}`}
                  markets={marketType.markets}
                  addBetSlip={addBetSlip}
                  event={event}
                  highestNumberOfMarkets={highestNumberOfMarkets}
                  line={line}
                />
              );

            case MarketTypes.HANDICAP:
              return (
                <AsianEventMarketHandicapContainer
                  markets={marketType.markets}
                  addBetSlip={addBetSlip}
                  event={event}
                  key={`${event.id}_${marketType.marketType}`}
                  highestNumberOfMarkets={highestNumberOfMarkets}
                  line={line}
                />
              );
            case MarketTypes.OUTRIGHT:
              return (
                <AsianEventCellOutright
                  marketPeriods={[marketPeriod]}
                  event={event}
                  highestNumberOfMarkets={highestNumberOfMarkets}
                  addBetSlip={addBetSlip}
                />
              );

            default:
              return null;
          }
        })}
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  line: state.asianCompetitionListFiltersModel.line,
});

function mapDispatchToProps(dispatch) {
  return {
    setEventMarketPeriodSummarized: (
      eventMarketPeriod: EventMarketPeriodType
    ) => dispatch.singleEventModel.setMarketPeriod(eventMarketPeriod),
    subscribeMarkets: (marketIdList: number[]) =>
      dispatch.subscribeModel.subscribeMarkets({
        marketIdList: marketIdList,
      }),
    unsubscribeMarkets: (marketIdList: number[]) =>
      dispatch.subscribeModel.unsubscribeMarkets({
        marketIdList: marketIdList,
      }),
    addBetSlip: (betSlip: EventType) =>
      dispatch.betSlipListModel.addBetSlip(betSlip),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AsianEventMarketPeriod) as any;
